import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { eDocs } from '../../../../redux/e-docs/action';
import { selectEDocsQueryItems } from '../../../../redux/e-docs/selector';
import { useAppDispatch } from '../../../../hooks/hooks';
import * as R from 'ramda';
import { toast } from 'react-toastify';
import PageLoader from '../../../../components/PageLoader';
import Table from '../../../../common/components/table';
import { UploadEDocContainer } from '../../../../models/upload-e-doc-modal';


const EDoc = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectEDocsQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    documents,
    setDocuments
  ] = useState([]);
  const [
    documentDetails,
    setDocumentDetails
  ] = useState<any>([]);
  const [
    documentBreadCrumbs,
    setDocumentBreadCrumbs
  ] = useState<any>([]);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    viewData,
    setViewData
  ] = useState<any>([]);


  const [
    open,
    setOpen
  ] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Type', headerName: 'View', sortable: false, filter: false, cellRenderer: 'viewRenderer'
      },
      {
        field: 'Url', headerName: 'Copy Url', sortable: false, filter: false, cellRenderer: 'copyRenderer'
      },
      { field: 'Name', headerName: 'Name', sortable: false, filter: false, },
      { field: 'DateCreated', headerName: 'Date Created', isDateValueFormat: true, sortable: true },
      { field: 'DateModified', headerName: 'Date Modified', isDateValueFormat: true, sortable: true }
    ]);
  }


  const fetchDocumentById = (id: any, isAccountDigiitFolder: any) => {
    dispatch(eDocs.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/query`, entity: 'eDocs', jsonData: {
        Records: [
          {
            "Id": id,
            "IsAccountDigiiFolder": isAccountDigiitFolder
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {

      if (isQuery) {
        setDocuments(queryItems?.result?.itemsRecords)
        setDocumentBreadCrumbs(queryItems?.result?.itemsParents)
        const findData = R.find(
          (parent: any) => parseInt(
            parent.Id,
            10
          ) === parseInt(
            parmas?.id,
            10
          ),
          queryItems?.result?.itemsParents
        )

        setDocumentDetails(findData)
      }
    },
    [isQuery, queryItems]
  )


  const handleEdit = async (data: any) => {
    if (data.Type === 'Folder') {
      navigate(`/management/cms/e-docs/${data?.Id}`)
      fetchDocumentById(data?.Id, documentDetails?.IsAccountDigiiFolder || false)
    } else {
      setOpen(true);
      setViewData(data)
    }
  }

  const handleFileClick = async (name: any, files: any) => {
    const frmData = new FormData();
    frmData.append(
      'ParentId',
      parmas?.id
    )
    frmData.append(
      'DocTypeName',
      name
    )
    frmData.append(
      'documents',
      files
    )
    frmData.append(
      'IsAccountDigiiFolder',
      documentDetails?.IsAccountDigiiFolder
    )
    if (name !== 'folder') {
      dispatch(eDocs.uploadCreate({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/uploadfile`,
        entity: 'eDocs',
        jsonData:
          frmData
      })).then(() => {
        fetchDocumentById(parmas?.id, documentDetails?.IsAccountDigiiFolder || false);
      })
    }
    else {
      await dispatch(eDocs.resetAction({ actionType: 'update' }))
      await dispatch(eDocs.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs`, entity: 'blogRequests', jsonData: {

          Records: [
            {
              ParentId: parmas?.id,
              NewFolderName: [files],
              IsAccountDigiiFolder: documentDetails?.IsAccountDigiiFolder
            }
          ]

        }
      })).then(() => {
        toast.info(`Add ${name} Succesfully`);
        fetchDocumentById(parmas?.id, documentDetails?.IsAccountDigiiFolder || false);
      })
    }
  }



  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchDocumentById(parmas?.id, documentDetails?.IsAccountDigiiFolder || false)
        createColumnDefs()
        setIsLoading(false)

      }
      else {
        setIsLoading(false)

      }
    },
    []
  )

  const hanldeHome = () => {
    navigate('/management/cms/e-docs')
  }

  const hanldeBack = async (data: any) => {
    navigate(`/management/cms/e-docs/${data?.Id}`)
    const documentDetail = documentDetails?.IsAccountDigiiFolder || false
    fetchDocumentById(data?.Id, documentDetail)
  }

  const handleDelete = (data: any) => {
    console.log(data, 'data')
    dispatch(eDocs.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/e-docs/delete`,
      entity: 'eDocs',
      jsonData: {
        Records: [
          {
            "Id": data?.Id,
            "Type": data?.Type,
            "IsAccountDigiiFolder": data?.IsAccountDigiiFolder
          }

        ]
      }
    })).then(() => {
      fetchDocumentById(parmas?.id, documentDetails?.IsAccountDigiiFolder || false);
    })
  }

  return (
    <>
      {open
        ? <>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-3xl mx-auto bg-white rounded-lg shadow-lg">
              <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
                <h6 className="text-lg font-medium">View {viewData?.Type}</h6>
                <button
                  aria-label="close"
                  className="p-2 text-gray-500 hover:text-gray-700"
                  onClick={handleClose}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="px-6 py-4">
                {viewData?.Type === 'Image' && (
                  <div className="flex justify-center">
                    <img
                      alt="Product"
                      src={viewData?.Url}
                      className="max-w-full max-h-80 border-none"
                    />
                  </div>
                )}
                {viewData?.Type === 'Video' && (
                  <div className="flex justify-center">
                    <video
                      autoPlay
                      controls
                      loop
                      muted
                      preload="auto"
                      src={viewData?.Url}
                      className="max-w-full max-h-80"
                    />
                  </div>
                )}
                {viewData?.Type === 'Document' && (
                  <iframe
                    src={viewData?.Url}
                    title="Document"
                    className="w-full h-96"
                  />
                )}
              </div>
            </div>
          </div>

        </>
        : null}
      <div className="space-y-4">
        <div className="text-start">
          <nav aria-label="breadcrumb">
            <ul className="flex space-x-2 text-blue-600">
              <li>
                <button
                  onClick={hanldeHome}
                  className="text-blue-600 hover:underline"
                >
                  Home
                </button>
              </li>
              {documentBreadCrumbs && documentBreadCrumbs?.map((item: any, index: any) => (
                <li key={index}>
                  <button
                    onClick={() => hanldeBack(item)}
                    className="text-blue-600 hover:underline"
                  >
                    {item?.Name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <div className=' text-end'>
        {handleFileClick
          ? <UploadEDocContainer
            childAddable={documentDetails}
            onFileClick={handleFileClick}
          />
          : null}
      </div>
      {isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={documents} onDelete={handleDelete} isEdocs
          onEdit={handleEdit} headingName="E Docs" />
      }
    </>
  )

}

export default EDoc;
